import { lineOf, useArtColours } from '../motion/art-colours';

/** The card's own colour, and the default paper: whatever is filled with it hides the lines behind it. */
export const CARD = '#FFEDDF';

export function useLine() {
	return lineOf(useArtColours().ink, 4);
}

/** Seconds per loop of the whole scene. */
export const LOOP = 6;
